// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"87":"373070db19ffb20d06bc","148":"492e2343b8c0f3aa154f"}[chunkId] + ".chunk.js";
};